import { PropsWithChildren } from "react"
import { Stack } from "@mui/material"
import { makeStyles } from "tss-react/mui"

const useStyles = makeStyles()((theme) => ({
    root: {
        position: "absolute",
        top: theme.spacing(0.5),
        right: theme.spacing(2),
    },
}))

type StandardTabsRowActionsProps = Readonly<PropsWithChildren>

export function StandardTabsRowActions({ children }: StandardTabsRowActionsProps) {
    const { classes } = useStyles()

    return (
        <Stack direction="row" spacing={1.25} className={classes.root}>
            {children}
        </Stack>
    )
}
